export const prices = {
  chipMinimizer: '$220',
  plumbingDisconnect: '$165',
  plumbingReconnect: '$341',
  tearoutLaminate: '$9/sq ft',
  tearoutOther: '$13.50/sq ft',
  digitalRendering: '$225',
  secondTrip: '$250',
  tileInstallation: '$59/SQFT',
  tileDeluxe: '$65/SQFT'
};
